import {
  AspectRatio,
  COLOR_PALETTE,
  Ellipsis,
  Group,
  OptimizeImage,
  Text,
  desktopFirstMediaQuery,
} from '@inflearn/ds-react-next';

import type { GetEnrollmentVerificationResponse } from '../../../../../resources/@types/courseSchema';
import { COURSE_URL } from '../../../../constants/urls';
import DownloadCertificationButton from './DownloadCertificationButton';

type EnrollmentVerification = GetEnrollmentVerificationResponse;

type VoucherItemProps = EnrollmentVerification & {
  realName?: string;
};

export default function VoucherItem({ realName, ...props }: VoucherItemProps) {
  return (
    <Group
      gap={16}
      wrap="nowrap"
      justify="space-between"
      styles={{
        root: {
          ...(props.isConfirmed && {
            filter: 'grayscale(1) opacity(0.6)',
          }),
        },
      }}
    >
      <AspectRatio
        w={{
          base: 78,
          sm: 90,
        }}
        h={{
          base: 48,
          sm: 55.64,
        }}
        ratio={1.618}
        styles={{
          root: {
            flexShrink: 0,
            borderRadius: 8,
            overflow: 'hidden',
            border: `1px solid ${COLOR_PALETTE.gray[2]}`,
            img: {
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              flexShrink: 1,
            },
            [desktopFirstMediaQuery.mobile]: {
              alignSelf: 'start',
            },
          },
        }}
      >
        <a
          href={COURSE_URL.COURSE_DETAIL(props.courseSlug)}
          aria-label={`${props.courseTitle} 상세페이지로 이동하기`}
        >
          <OptimizeImage
            w={90 * 2}
            width="100%"
            src={props.courseThumbnailUrl}
            alt={`${props.courseTitle} 강의 썸네일`}
          />
        </a>
      </AspectRatio>

      <Ellipsis lineClamp={2}>
        <Text
          fw={500}
          component="a"
          aria-label={`${props.courseTitle} 상세페이지로 이동하기`}
          href={COURSE_URL.COURSE_DETAIL(props.courseSlug)}
          styles={{
            root: {
              flex: '1 1 auto',
              '&:hover': {
                cursor: 'pointer',
                textDecoration: 'underline',
              },
              [desktopFirstMediaQuery.mobile]: {
                fontSize: 14,
              },
            },
          }}
        >
          {props.courseTitle}
        </Text>
      </Ellipsis>
      <DownloadCertificationButton
        realName={realName}
        voucher={{
          id: props.id,
          courseId: props.courseId,
          createdAt: props.createdAt,
          courseTitle: props.courseTitle,
        }}
      />
    </Group>
  );
}
